module.exports = __webpack_public_path__ + "static/media/recipient-template-tauron.45f8539d.xlsx";